import { Icon } from '@gitbook/spine-icons';

import { SidebarButton, type SidebarButtonProps } from './SidebarItem';

interface SidebarToggleButtonProps extends SidebarButtonProps {
    isCollapsed: boolean;
    onCollapse: () => void;
    onUncollapse: () => void;
    className?: string;
}

/**
 * Sidebar toggle button that can be used outside of the resizable sidebar.
 */
export function SidebarToggleButton(props: SidebarToggleButtonProps) {
    const { isCollapsed, onCollapse, onUncollapse, className, outlined = false } = props;

    return (
        <SidebarButton
            data-testid="sidebar.toggleButton"
            label={isCollapsed ? 'Anchor sidebar' : 'Hide sidebar'}
            icon={isCollapsed ? Icon.PanelLeftOpen : Icon.PanelLeftClose}
            className={className}
            iconOnly
            outlined={outlined}
            onPress={() => {
                if (isCollapsed) {
                    onUncollapse();
                } else {
                    onCollapse();
                }
            }}
        />
    );
}
